import { Component } from '@angular/core';
import { ForgotPasswordComponent as FsfForgotPasswordComponent } from '@freesixtyfive/fe-login-process';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [FsfForgotPasswordComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {}
